import { render, staticRenderFns } from "./BTableView.vue?vue&type=template&id=6aaa0d3b&scoped=true&"
import script from "./BTableView.vue?vue&type=script&lang=js&"
export * from "./BTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa0d3b",
  null
  
)

export default component.exports